import { useEffect, useMemo, useState } from 'react';

import { Link } from '@playbooks/ui/components/link';
import { cn } from '@playbooks/ui/lib/utils';

export const TocElement = ({ size, ...props }) => {
	const [show, setShow] = useState(false);

	// Computed
	const spacing = useMemo(() => {
		switch (size) {
			case 'h2':
				return 'pl-2';
			case 'h3':
				return 'pl-2';
			case 'h4':
				return 'pl-4';
			case 'h5':
				return 'pl-6';
			case 'h6':
				return 'pl-8';
		}
	}, [props]);

	// Hooks
	useEffect(() => {
		// logger.log('TocElement: ', props);
	}, []);

	// Theme
	const rootClassName = cn('text-left block hover:underline opacity-80 hover:opacity-100', spacing);

	// Render
	return (
		<Link variant='link' href={'#' + props.id} className={rootClassName}>
			<span data-scrollspy={props.id}>{props.children}</span>
		</Link>
	);
};
// Docs
// scrollspy
// id generation
